import React, { useState } from 'react'
import { useStyles } from './HeaderStyle'
//Material UI
import Select from '@material-ui/core/Select'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Container from '@material-ui/core/Container'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import Alert from '@material-ui/lab/Alert'
import 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import { useLocation } from 'react-router-dom'


const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
}

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

  
export default function Header(props) {
  const classes = useStyles()
    
  const [selectedDate, setSelectedDate] = useState(new Date())

  const { centerList, setCentre, selectDate } = props

  const setDate = (date) => {
    setSelectedDate(date)
    selectDate(date)
  }
  let query = useQuery()

  return (
    <Container className={classes.page} >
      {props.move && <Alert severity="warning"><strong>Vous modifiez une reservation.</strong> Veuillez selectionner le creneau sur le quel déplacer la reservation</Alert>}
      <h1 style={{ color:'#2980b9' }}>{query.get('creId') ? 'Modification de la reservation' : 'Planning des réservations' }</h1>
      <h3>{query.get('creId') ? 'Veuillez selectionner un autre créneau' : null }</h3>
      
      <div className={classes.inputs}>
        <FormControl>
          <InputLabel id="label-center">Centre</InputLabel>
          <Select
            labelId="selec-label-center"
            id="select-center"
            input={<Input />}
            defaultValue={centerList[0].CNT_ID}
            MenuProps={MenuProps}
            onChange={e => setCentre(e.target.value)}
          >
            {centerList.map((item, i) => (
              <MenuItem key={i} value={item.CNT_ID}>
                {item.CNT_LIBELLE}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <MuiPickersUtilsProvider utils={DateFnsUtils} >
          <DatePicker
            disableToolbar
            autoOk
            variant="inline"
            label="Date"
            helperText="Sélection de la date"
            format="dd/MM/yyyy"
            minDate={new Date()}
            maxDate={new Date().setDate(new Date().getDate() + 6)}
            value={selectedDate}
            onChange={setDate}
          />
        </MuiPickersUtilsProvider>
      </div>
      
    </Container>
  )
}
